import React from 'react';
import RecipientNameLegalConfirmPopup from './RecipientNameLegalConfirmPopup';
import { NextoneOrderClientContext } from '../../context/NextoneOrderClientContext';
import RecipientCopyrightTransferFormView1 from './RecipientCopyrightTransferFormView1';
import RecipientCopyrightTransferFormView2 from './RecipientCopyrightTransferFormView2';
import { FieldValidationErrorsType, showErrorFlush } from '../../../common/form/FrekulForm';

type RecipientCopyrightTransferFormViewName = 'view1'|'view2';
type RecipientCopyrightTransferFormPopupName = 'confirm';
type RecipientCopyrightTransferFormAjaxName = 'validate'|'execute';

export default function RecipientCopyrightTransferForm({
  formHash,
  karaokeOrder,
  document,
} : {
  document: string,
  formHash: string,
  karaokeOrder: {
    applicant_name: string,
    applicant_address: string,
  },
}) {

  const [view, setView] = React.useState<RecipientCopyrightTransferFormViewName>('view1');
  const [popup, setPopup] = React.useState<RecipientCopyrightTransferFormPopupName|null>(null);
  const [ajax, setAjax] = React.useState<RecipientCopyrightTransferFormAjaxName|null>(null);
  const [preview, setPreview] = React.useState<string|null>(null);
  const [errors, setErrors] = React.useState<{ [key: string]: FieldValidationErrorsType }>({});

  const {
    validateRecipientCopyrightTransfer,
    executeRecipientCopyrightTransfer,
  } = React.useContext(NextoneOrderClientContext);

  React.useEffect(() => {
    if (ajax === 'validate') {
      validateRecipientCopyrightTransfer(formHash).then((responseData) => {
        setAjax(null);
        setErrors(responseData.validationErrors as { [key: string]: FieldValidationErrorsType });
        if (responseData.result) {
          setPreview(responseData.document);
          setView('view2');
        } else {
          showErrorFlush('入力内容に不備があります。')
        }
      });
    } else if (ajax === 'execute') {
      executeRecipientCopyrightTransfer(formHash).then((responseData) => {
        setAjax(null);
        setErrors(responseData.validationErrors as { [key: string]: FieldValidationErrorsType });
        if (responseData.result) {
          window.location.href = `/nextone_orders/recipient_copyright_transfer_completed/${formHash}`;
        } else {
          showErrorFlush('入力内容に不備があります。')
        }
      });
    }
  }, [ajax]);

  const topRef = React.useRef(null);
  React.useEffect(() => {
    (topRef.current as HTMLElement|null)?.scrollIntoView();
  }, [view]);

  return (
    <>
      <div ref={topRef} />
      {view === 'view1' && (
        <RecipientCopyrightTransferFormView1
          document={document}
          karaokeOrder={karaokeOrder}
          onNext={() => setPopup('confirm')}
        />
      )}
      {view === 'view2' && preview !== null && (
        <RecipientCopyrightTransferFormView2
          document={preview}
          karaokeOrder={karaokeOrder}
          onNext={() => setAjax('execute')}
          onBack={() => setView('view1')}
        />
      )}
      {popup === 'confirm' && (
        <RecipientNameLegalConfirmPopup
          recipientName={karaokeOrder.applicant_name}
          onCancel={() => setPopup(null)}
          onConfirm={() => {
            setPopup(null);
            setAjax('validate');
          }}
        />
      )}
    </>
  );
}
